import React, { useCallback } from "react";

import { mdiSortVariant } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";

import type { JSX } from "react";

import type { IndexFastMediaItem } from "../../../api/MediaAPI.types";

export interface Order {
  direction: "up" | "down";
  field: keyof IndexFastMediaItem;
}

interface MediaLibraryOrderProps {
  order: Order;
  setOrder: (order: Order) => void;
}

function MediaLibraryOrder({
  setOrder,
  order,
}: MediaLibraryOrderProps): JSX.Element {
  const handleSortMedias = useCallback((): void => {
    setOrder({
      direction: order.direction === "down" ? "up" : "down",
      field: "label",
    });
  }, [order.direction, setOrder]);

  const sortIconClassNames = classNames({
    "scale-y-[-1]": order.direction === "down",
  });

  return (
    <button
      className="border-input bg-card my-[0.3125rem] flex cursor-pointer items-center gap-[0.3125rem] rounded-[0.3125rem] border px-[0.46875rem]"
      onClick={handleSortMedias}
      type="button"
    >
      <Icon
        className={sortIconClassNames}
        path={mdiSortVariant}
        size={0.9375}
      />
      <span className="whitespace-nowrap">
        {order.direction === "up" ? "A-z" : "Z-a"}
      </span>
    </button>
  );
}

export default MediaLibraryOrder;
